module.exports = __webpack_public_path__ + "static/media/instructivo1.d9ed092f.png";